import React from 'react';
import { FileText } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import SaveToLibraryButton from '@/components/library/SaveToLibraryButton';

const ListSection = ({ title, items }) => (
  <div>
    <h4 className="font-semibold text-stone-900 mb-2">{title}</h4>
    <ul className="list-disc list-inside space-y-1 text-stone-700">
      {items?.map((item, idx) => <li key={idx}>{item}</li>)}
    </ul>
  </div>
);

export const GeneratedLessonView = ({ lesson, context, canSaveToUnit, onSaveToUnit }) => {
  if (!lesson) {
    return (
      <Card className="p-12 text-center">
        <FileText className="h-16 w-16 text-stone-300 mx-auto mb-4" />
        <h3 className="text-xl font-serif text-stone-900 mb-2">No Lesson Plan Yet</h3>
        <p className="text-stone-600">Select a template, provide context, and generate your lesson plan</p>
      </Card>
    );
  }

  return (
    <Card className="p-8">
      <div className="flex items-center justify-between mb-6 gap-3 flex-wrap">
        <h3 className="text-2xl font-serif font-normal text-stone-900">Generated Lesson Plan</h3>
        <div className="flex items-center gap-2 flex-wrap">
          <SaveToLibraryButton
            artifactType="lesson_plan"
            title={lesson.title || context.unit_title || 'Untitled Lesson'}
            description={lesson.description || ''}
            gradeLevel={context.grade_level}
            unitTitle={context.unit_title}
            content={lesson}
          />
          {canSaveToUnit && (
            <Button onClick={onSaveToUnit} className="btn-primary" data-testid="save-lesson-btn">
              Add to Unit
            </Button>
          )}
        </div>
      </div>

      <div className="space-y-6">
        <div>
          <h4 className="font-semibold text-stone-900 mb-2">Title</h4>
          <p className="text-stone-700">{lesson.title}</p>
        </div>
        <div>
          <h4 className="font-semibold text-stone-900 mb-2">Description</h4>
          <p className="text-stone-700 leading-relaxed">{lesson.description}</p>
        </div>
        <ListSection title="Learning Objectives" items={lesson.objectives} />
        <ListSection title="Materials Needed" items={lesson.materials} />
        <div>
          <h4 className="font-semibold text-stone-900 mb-2">Duration</h4>
          <p className="text-stone-700">{lesson.duration}</p>
        </div>
        <div>
          <h4 className="font-semibold text-stone-900 mb-2">Instructions</h4>
          <p className="text-stone-700 whitespace-pre-wrap leading-relaxed">{lesson.instructions}</p>
        </div>
        <ListSection title="Assessment Criteria" items={lesson.assessment_criteria} />
      </div>
    </Card>
  );
};
